import script from "./UserProfileCompletionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileCompletionDialog.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileCompletionDialog.vue?vue&type=style&index=0&id=7a568e70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a568e70"]])

export default __exports__